import { useEffect, useRef, useState } from 'react'
import Logo from './../../Assets/Images/logo-02.png'
import { Link, useLocation, useParams } from 'react-router-dom'

import ReCAPTCHA from "react-google-recaptcha";
import { useLazyQuery, useMutation } from '@apollo/client';
import { APP_ACCOUNT_DELETE_CONFIRMATION, APP_ACCOUNT_DELETE_STATUS } from '../../graphql/Auth/auth';
import { useForm } from 'react-hook-form';

const DataDeletionRequest = () => {

  const { token } = useParams()

  const [email, setEmail] = useState('')
  const [comments, setComments] = useState('')
  const [loading, setLoading] = useState(false)

  //Confirmation of data deletion
  const recaptcha = useRef(null)

  const [requestStatus, reqPayload] = useLazyQuery(APP_ACCOUNT_DELETE_STATUS)

  const [requestConfirm] = useMutation(APP_ACCOUNT_DELETE_CONFIRMATION)

  useEffect(() => {
    if (token) {
      requestStatus({
        variables: {
          payload: token
        }
      }).then((res) => {
        if (res.data.appAccountDeleteStatus.expired) {
          alert('El token ha expirado')
          window.location.href = '/'
        }
      })
    }
    return () => { }
  }, [token])

  // Submission of data deletion confirmation
  const handleDeleteConfirmation = async (e) => {
    e.preventDefault()
    const recaptchaValue = recaptcha.current.getValue()
    if (!recaptchaValue) {
      alert('Por favor, completa el reCAPTCHA.')
      return
    }

    const emailInput = document.getElementById('email')
    if (emailInput.value.toLowerCase() !== reqPayload?.data?.appAccountDeleteStatus?.userEmail?.toLowerCase()) {
      alert('El correo electrónico no coincide con el asociado a la cuenta.')
      return
    }

    try {
      const response = await requestConfirm({
        variables: {
          payload: token
        }
      })

      if (response?.data?.appAccountDeleteConfirm) {
        alert('Eliminación de datos confirmada')
        window.location.href = '/'
      }

    } catch (error) {
      alert('El token ha expirado, vuelve a solicitar la eliminación de datos')
      return
    }


  }

  // Submission of data deletion request
  const handleSubmit = (e) => {
    e.preventDefault()
    const recaptchaValue = recaptcha.current.getValue()
    if (!recaptchaValue) {
      alert('Por favor, completa el reCAPTCHA.')
      return
    }
    const emailInput = document.getElementById('email')
    if (!emailInput.value) {
      alert('Por favor, completa el correo electrónico.')
      return
    }
    const commentsInput = document.getElementById('comments')
    if (!commentsInput.value) {
      alert('Por favor, completa los comentarios.')
      return
    }
    const payload = {
      email: emailInput.value,
      comments: commentsInput.value,
      recaptcha: recaptchaValue
    }

    alert('Solicitud enviada')
  }

  if (token) {
    return (
      <div className="full-container">
        <img src={Logo} className="img-logo-full" alt="logo" />
        <span>Confirmación de eliminación de datos </span>
        <div className="full-box" id="boxLogin">
          <p className="text-justify">
            Hola, {reqPayload?.data?.appAccountDeleteStatus?.userName} confirmas que deseas eliminar tus datos de la plataforma?
            <br />
            <br />
            Completa el siguiente formulario para confirmar la eliminación de tus datos.
          </p>

          <form onSubmit={handleDeleteConfirmation}>
            <label
              htmlFor="email">
              Completa el correo asociado a tu cuenta:<br />
              {reqPayload?.data?.appAccountDeleteStatus?.userEmail.split("@")[0].substring(0, 2).concat("*********").concat("@").concat(reqPayload?.data?.appAccountDeleteStatus?.userEmail.split("@")[1])}
            </label>
            <input
              className="form-control"
              type="email"
              id="email"
            />
            <ReCAPTCHA
              ref={recaptcha}
              style={{ marginTop: 16, textAlign: "center" }}
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY} />
            <div className="items-center mt-2"></div>
            <button
              className="btn btn-migrates btn-login"
              type="submit"
            >
              Confirmar eliminación de datos
            </button>
          </form>
        </div>

      </div>
    )
  }


  return (
    <div className="full-container">
      <Link to="/" className="h1 d-flex justify-content-center mb-5 mt-5">
        <img src={Logo} className="img-logo-full" alt="logo" />
      </Link>
      <span>Solicitud de Eliminación de Datos</span>
      <div className="full-box" id="boxLogin">
        <form onSubmit={handleSubmit} className="row">
          <label htmlFor="email">Correo electrónico:</label>
          <input
            className="form-control"
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <br />
          <label htmlFor="comments">Comentarios (opcional):</label>
          <textarea
            id="comments"
            value={comments}
            className="form-control"
            onChange={(e) => setComments(e.target.value)}
            rows="4"
          />
          <div className="login-btn col-12 items-center ">

            {loading ? (
              <button
                className="btn btn-migrates btn-login"
                type="button"
                disabled
              >
                <span
                  className="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Procesando...</span>
              </button>
            ) : (
              <button type="submit" className="btn btn-migrates">
                Enviar solicitud
              </button>
            )}

          </div>
          <br />
          <label htmlFor="recaptcha">
            Verificación de seguridad:
            <br />
            Por favor, completa el reCAPTCHA para enviar tu solicitud.
          </label>
          <br />
          <ReCAPTCHA
            style={{ textAlign: "center" }}
            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
            ref={recaptcha}
          />
        </form>
      </div>
    </div>
  )
}

export default DataDeletionRequest
